module.exports = __webpack_public_path__ + "img/brand--makro.cc1bc013.png";